import logo from '../images/unum-logo.svg';
import desktopImage from '../images/loading-screen-clouds-desktop.svg';
import mobileImage from '../images/loading-screen-clouds-mobile.svg';

export const loadingScreenTestData = {
  unumLogo: logo,
  bottomImage: mobileImage,
  bottomImageDesktop: desktopImage,
};
